module.exports = __webpack_public_path__ + "assets/img/scss_variable.300e72a5.jpg";